import { FeesRepo } from '../../fees.repo';
import * as _ from 'lodash';
import * as moment from 'moment';
import { FeeCalculationType } from '../../../common/enums/FeeCalculation'

class FinalRunController {

  // filter options
  public fromDate;
  public toDate;
  public searchFiltersList;
  public endOfLastMonth;
  public currentDate;
  public lastTwelveMonths;

  // Calculation Type
  public displayMCB: boolean = true;
  public selectedCurrency = "MUR";

  public clientFeeParameters;

  public selectAll: boolean = false;

  public isLoadingParameters: boolean = false;
  public isSavingParameters: boolean = false;

  public reloadFinalParameters: boolean = false;


  // stats

  public totalNav: number = 0;

  public totalFeeValue: number = 0;

  public totalPortfolios: number = 0;

  public midRates: Array<any>;

  public midRateDate;

  public threshold: number = 10;

  /** @ngInject */
  constructor(private feesRepo: FeesRepo, private notifyjs, private $mdDialog: angular.material.IDialogService,
    private $rootScope: angular.IRootScopeService, private $window: angular.IWindowService) {

    var date = new Date();
    this.currentDate = date;

    this.endOfLastMonth = moment(date).subtract(1, 'months').endOf('month');
    this.lastTwelveMonths = new Date(moment(date).subtract(18, 'months').endOf('month').format('YYYY-MM-DD'))
    this.searchFiltersList = [
      {
        name: "Last Month",
        fromDate: moment(date).subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        toDate: moment(date).subtract(1, 'months').endOf('month').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Last Quarter",
        fromDate: moment().subtract(1, 'Q').startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().subtract(1, 'Q').endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "First Quarter",
        fromDate: moment().quarter(1).startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().quarter(1).endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Second Quarter",
        fromDate: moment().quarter(2).startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().quarter(2).endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Third Quarter",
        fromDate: moment().quarter(3).startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().quarter(3).endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Fourth Quarter",
        fromDate: moment().quarter(4).startOf('quarter').format('YYYY-MM-DD'),
        toDate: moment().quarter(4).endOf('quarter').format('YYYY-MM-DD'),
        active: false
      },
      {
        name: "Last 12 Months",
        fromDate: moment(date).subtract(12, 'months').endOf('month').format('YYYY-MM-DD'),
        toDate: moment().add(-1, 'days').format('YYYY-MM-DD'),
        active: false
      }
    ]

    if (_.isEmpty(this.fromDate) || _.isEmpty(this.toDate)) {
      this.fromDate = new Date(this.searchFiltersList[0].fromDate);
      this.toDate = new Date(this.searchFiltersList[0].toDate);
      this.searchFiltersList[0].active = true;
      this.getFinalRunParameters()
      this.midRateDate = new Date(this.searchFiltersList[0].toDate);
      this.getMidRateForMonth();
    }
  }


  $onChanges(changes) {
    if (changes.reloadFinalParameters) {
      this.getFinalRunParameters();
    }
  }


  getFinalRunParameters = () => {
    let feeCalculationType = this.displayMCB ? FeeCalculationType.MCB : FeeCalculationType.EDR
    this.isLoadingParameters = true;
    let fromDate = moment(this.fromDate).endOf('month').format('YYYY-MM-DD');
    let toDate = moment(this.toDate).endOf('month').format('YYYY-MM-DD');
    this.feesRepo.getFinalRunParameters(fromDate, toDate, feeCalculationType)
      .then(res => {
        this.clientFeeParameters = [];
        this.clientFeeParameters = res.data as Array<any>;

        this.clientFeeParameters.forEach(client => {
          client.isSelected = this.selectAll;
          client.portfolioFees.forEach(fee => {
            fee.portfolios.forEach(portfolio => {
              if (portfolio) {
                portfolio.isSelected = this.selectAll;
              }
            })
          })
        });

        this.setTotalNav();
        this.setTotalFeeValue();
        this.setTotalPortfolios();
      })
      .catch(err => {
        this.notifyjs("Failed to load fee parameters " + err.data)
      })
      .finally(() => { this.isLoadingParameters = false; })
  }


  filterFeeParameters = (filter) => {
    _.forEach(this.searchFiltersList, (filterOption) => {
      if (filterOption.name !== filter.name) {
        filterOption.active = false
      }
    })
    filter.active = true
    this.fromDate = new Date(filter.fromDate);
    this.toDate = new Date(filter.toDate);
    this.getFinalRunParameters()
  }

  toDateChanged = () => {
    _.forEach(this.searchFiltersList, (filterOption) => {
      filterOption.active = false
    });
    this.getFinalRunParameters();
  }

  fromDateChanged = () => {
    if (this.fromDate < this.toDate) {
      _.forEach(this.searchFiltersList, (filterOption) => {
        filterOption.active = false
      });
      this.getFinalRunParameters();
    }
  }

  selectAllClients = () => {
    this.clientFeeParameters.forEach(client => {
      client.isSelected = this.selectAll;
      client.portfolioFees.forEach(fee => {
        fee.portfolios.forEach(portfolio => {
          portfolio.isSelected = this.selectAll;
        })
      })
    });
  }

  getPercentageFromDecimal = (value) => {
    return +(value * 100).toFixed(2)
  }

  getPortfolioSelectedText = (client) => {
    let totalPortfoliosSelected = client.portfolioFees.reduce((acc, pf) => {
      return acc + pf.portfolios.filter(p => p && p.isSelected).length
    }, 0);

    let totalPortfolios = client.portfolioFees.reduce((acc, pf) => {
      return acc + pf.portfolios.length
    }, 0);

    if (totalPortfolios == totalPortfoliosSelected) {
      return "All portfolio(s)"
    } else {
      return `${totalPortfoliosSelected} of ${totalPortfolios} portfolio(s) `
    }

  }

  selectAllClientPortfolios = (client) => {
    client.portfolioFees.forEach(fee => {
      fee.portfolios.forEach(portfolio => {
        portfolio.isSelected = client.isSelected;
      })
    })
  }


  convertToLocaleTime = (date: any) => {
    date = new Date(date)
    return moment(date).format('YYYY-MM-DD')

  }

  displayFeeSummary = (client) => {
    client.displayFeeSummary = !client.displayFeeSummary;
  }


  stopPropagation = ($event: angular.IAngularEvent) => {
    $event.stopPropagation();
  }

  selectPortfolio = (portfolio, client) => {
    if (!portfolio.isSelected) {
      client.isSelected = portfolio.isSelected;
    }
    else {
      let totalPortfolios = client.portfolioFees.reduce((acc, pf) => {
        return acc + pf.portfolios.length
      }, 0);

      let totalPortfoliosSelected = client.portfolioFees.reduce((acc, pf) => {
        return acc + pf.portfolios.filter(p => p.isSelected).length
      }, 0);

      client.isSelected = totalPortfolios == totalPortfoliosSelected
    }
  }

  declineInstruction = (feeInstructionId) => {
    this.feesRepo.declineFeeInstruction(feeInstructionId)
      .then(res => {
        this.getFinalRunParameters()
      })
      .catch(err => {
        this.notifyjs("Failed to decline temp run " + err.data)
      })
  }

  canSaveFinalRun = () => {
    let totalPortfoliosSelected = 0;

    if (this.clientFeeParameters) {
      totalPortfoliosSelected = this.clientFeeParameters.reduce((a, client) => {
        return a + client.portfolioFees.reduce((acc, pf) => {
          return acc + pf.portfolios.filter(p => p && p.isSelected).length
        }, 0);
      }, 0)
    }
    return totalPortfoliosSelected <= 0
  }


  saveFinalRun = () => {
    let feeCalculationType = this.displayMCB ? FeeCalculationType.MCB : FeeCalculationType.EDR
    let instructionsParameters = []
    this.clientFeeParameters.forEach(client => {
      if (client) {
        client.portfolioFees.forEach(pf => {
          pf.portfolios.forEach(p => {
            if (p && p.isSelected) {
              instructionsParameters.push({
                clientId: client.id,
                portfolioId: p.portfolioId,
                portfolioFeeId: pf.portfolioFeeId,
                cashAccountId: p.cashAccountId,
                feeCalculationType: feeCalculationType,
                feeDate: client.feeDate,
                id: p.feeInstructionId,
                currency: p.currency
              })
            }
          })
        })
      }
    })

    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.selectedInstructions = instructionsParameters;

    this.$mdDialog.show({
      template: `<generate-instruction-sheet-dialog selected-instructions="selectedInstructions" ></generate-instruction-sheet-dialog>`,
      clickOutsideToClose: true,
      scope: tempScope
    })
      .then((result => {
        if (result) {
          this.getFinalRunParameters();
        }
      }))
  }

  formatDate(selectedDate) {
    return moment(selectedDate).endOf('month').format('YYYY-MM');
  }

  setTotalNav = () => {
    this.totalNav = this.clientFeeParameters.reduce((acc, client) => {
      if (client) {
        return acc + client.totalNavMUR
      }
    }, 0)
  }

  getSelectedNav = () => {
    let selectedNav = 0;
    if (this.clientFeeParameters.length > 0) {
      selectedNav = this.clientFeeParameters.reduce((a, client) => {
        if (client) {
          return a + client.portfolioFees.reduce((acc, pf) => {
            return acc + pf.portfolios.filter(p => p && p.isSelected).reduce((a, p) => {
              return a + p.marketValueMUR
            }, 0)
          }, 0);
        }
      }, 0)
    }
    return selectedNav;
  }


  setTotalFeeValue = () => {
    this.totalFeeValue = this.clientFeeParameters.reduce((acc, client) => {
      if (client) {
        return acc + client.totalFeeValueMUR
      }
    }, 0)
  }

  getSelectedFeeValue = () => {
    let selectedFeeValue = 0;
    if (this.clientFeeParameters.length > 0) {
      selectedFeeValue = this.clientFeeParameters.reduce((a, client) => {
        if (client) {
          return a + client.portfolioFees.reduce((acc, pf) => {
            return acc + pf.portfolios.filter(p => p && p.isSelected).reduce((a, p) => {
              return a + p.feeValueMUR
            }, 0)
          }, 0);
        }
      }, 0)
    }
    return selectedFeeValue;
  }


  setTotalPortfolios = () => {
    this.totalPortfolios = this.clientFeeParameters.reduce((a, client) => {
      if (client) {
        return a + client.portfolioFees.reduce((acc, pf) => {
          return acc + pf.portfolios.filter(p => p).length
        }, 0);
      }
    }, 0)
  }

  getSelectedPortfolios = () => {
    let selectedPortfolios = 0
    if (this.clientFeeParameters.length > 0) {
      selectedPortfolios = this.clientFeeParameters.reduce((a, client) => {
        if (client) {
          return a + client.portfolioFees.reduce((acc, pf) => {
            return acc + pf.portfolios.filter(p => p && p.isSelected).length
          }, 0);
        }
      }, 0)
    }
    return selectedPortfolios;
  }

  getMidRateForMonth = () => {
    let endOfMonthDate = moment(this.midRateDate).endOf('month').format('YYYY-MM-DD');
    this.feesRepo.getMidRate(endOfMonthDate)
      .then(res => {
        this.midRates = res.data as Array<any>;
      })
      .catch(err => {
        this.notifyjs("Failed to get mid rates for selected month " + err.data)
      })
  }

  hasFeeValueAboveThreshold = (portfolio) => {
    if (portfolio) {
      return portfolio.feeValueDelta * 100 > this.threshold || portfolio.feeValueDelta * 100 < -this.threshold
    }
  }

  hasInSufficientFunds = (portfolio) => {
    if (portfolio) {
      return portfolio.cashBalance <= 0
    }
  }

  clientHasFeeValueAboveThreshold = (client) => {
    if (client) {
      return client.portfolioFees.some(pf => {
        return pf.portfolios.some(p => {
          return p && (this.hasFeeValueAboveThreshold(p) || this.hasInSufficientFunds(p))
        })
      })
    }
  }

  generateAdhocFeeInstructionSheet = (includeInstructed) => {
    let feeCalculationType = this.displayMCB ? FeeCalculationType.MCB : FeeCalculationType.EDR
    this.isLoadingParameters = true;
    let fromDate = moment(this.fromDate).endOf('month').format('YYYY-MM-DD');
    let toDate = moment(this.toDate).endOf('month').format('YYYY-MM-DD');

    this.feesRepo.generateAdhocFeeInstructionSheet(fromDate,toDate,feeCalculationType,includeInstructed)
    .then((res) => {
      let instructionExcel = res.data as any;
      this.$window.open(instructionExcel.url, '_blank');
    })
    .catch(err => {
      this.notifyjs("Failed to generate ad-hoc instruction")
    })
    .finally(() => this.isLoadingParameters = false)
  }

  generateAdhocSheet = () => {
    let confirm = this.$mdDialog.confirm()
    .title('Would you like to include previously instructed fee values ? ')
    .ariaLabel('AdhocFeeInstruction')
    .targetEvent()
    .ok('Yes')
    .cancel('Cancel');

  let that = this;
  this.$mdDialog.show(confirm)
    .then(function () {
      that.generateAdhocFeeInstructionSheet(true)
    }, function () {
      that.generateAdhocFeeInstructionSheet(false)
    });
  }

  getAllFinalRunParameters = () => {
    this.fromDate = moment("2019-01-31").format('YYYY-MM-DD');
    this.toDate = moment(this.currentDate).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    this.getFinalRunParameters();
  }


}

export const finalRun: angular.IComponentOptions = {
  template: require('./fees.instructions.finalrun.html'),
  controller: FinalRunController,
  bindings: {
    reloadFinalParameters: "<"
  }
};



// WEBPACK FOOTER //
// ./src/app/fees/instructions/finalrun/fees.instructions.finalrun.ts